/**
 * Les départements où VLA Énergie installe : métropole, Corse, outre-mer.
 *
 * Le fuseau sert à afficher les dates d'un chantier à l'heure de son site
 * (docs/CADRAGE.md, « Contraintes de terrain »).
 */
export interface Departement {
  code: string;
  nom: string;
  region: string;
  fuseau: string;
}

const PARIS = 'Europe/Paris';

const METROPOLE: [string, string, string][] = [
  ['01', 'Ain', 'Auvergne-Rhône-Alpes'],
  ['02', 'Aisne', 'Hauts-de-France'],
  ['03', 'Allier', 'Auvergne-Rhône-Alpes'],
  ['04', 'Alpes-de-Haute-Provence', 'Provence-Alpes-Côte d’Azur'],
  ['05', 'Hautes-Alpes', 'Provence-Alpes-Côte d’Azur'],
  ['06', 'Alpes-Maritimes', 'Provence-Alpes-Côte d’Azur'],
  ['07', 'Ardèche', 'Auvergne-Rhône-Alpes'],
  ['08', 'Ardennes', 'Grand Est'],
  ['09', 'Ariège', 'Occitanie'],
  ['10', 'Aube', 'Grand Est'],
  ['11', 'Aude', 'Occitanie'],
  ['12', 'Aveyron', 'Occitanie'],
  ['13', 'Bouches-du-Rhône', 'Provence-Alpes-Côte d’Azur'],
  ['14', 'Calvados', 'Normandie'],
  ['15', 'Cantal', 'Auvergne-Rhône-Alpes'],
  ['16', 'Charente', 'Nouvelle-Aquitaine'],
  ['17', 'Charente-Maritime', 'Nouvelle-Aquitaine'],
  ['18', 'Cher', 'Centre-Val de Loire'],
  ['19', 'Corrèze', 'Nouvelle-Aquitaine'],
  ['2A', 'Corse-du-Sud', 'Corse'],
  ['2B', 'Haute-Corse', 'Corse'],
  ['21', 'Côte-d’Or', 'Bourgogne-Franche-Comté'],
  ['22', 'Côtes-d’Armor', 'Bretagne'],
  ['23', 'Creuse', 'Nouvelle-Aquitaine'],
  ['24', 'Dordogne', 'Nouvelle-Aquitaine'],
  ['25', 'Doubs', 'Bourgogne-Franche-Comté'],
  ['26', 'Drôme', 'Auvergne-Rhône-Alpes'],
  ['27', 'Eure', 'Normandie'],
  ['28', 'Eure-et-Loir', 'Centre-Val de Loire'],
  ['29', 'Finistère', 'Bretagne'],
  ['30', 'Gard', 'Occitanie'],
  ['31', 'Haute-Garonne', 'Occitanie'],
  ['32', 'Gers', 'Occitanie'],
  ['33', 'Gironde', 'Nouvelle-Aquitaine'],
  ['34', 'Hérault', 'Occitanie'],
  ['35', 'Ille-et-Vilaine', 'Bretagne'],
  ['36', 'Indre', 'Centre-Val de Loire'],
  ['37', 'Indre-et-Loire', 'Centre-Val de Loire'],
  ['38', 'Isère', 'Auvergne-Rhône-Alpes'],
  ['39', 'Jura', 'Bourgogne-Franche-Comté'],
  ['40', 'Landes', 'Nouvelle-Aquitaine'],
  ['41', 'Loir-et-Cher', 'Centre-Val de Loire'],
  ['42', 'Loire', 'Auvergne-Rhône-Alpes'],
  ['43', 'Haute-Loire', 'Auvergne-Rhône-Alpes'],
  ['44', 'Loire-Atlantique', 'Pays de la Loire'],
  ['45', 'Loiret', 'Centre-Val de Loire'],
  ['46', 'Lot', 'Occitanie'],
  ['47', 'Lot-et-Garonne', 'Nouvelle-Aquitaine'],
  ['48', 'Lozère', 'Occitanie'],
  ['49', 'Maine-et-Loire', 'Pays de la Loire'],
  ['50', 'Manche', 'Normandie'],
  ['51', 'Marne', 'Grand Est'],
  ['52', 'Haute-Marne', 'Grand Est'],
  ['53', 'Mayenne', 'Pays de la Loire'],
  ['54', 'Meurthe-et-Moselle', 'Grand Est'],
  ['55', 'Meuse', 'Grand Est'],
  ['56', 'Morbihan', 'Bretagne'],
  ['57', 'Moselle', 'Grand Est'],
  ['58', 'Nièvre', 'Bourgogne-Franche-Comté'],
  ['59', 'Nord', 'Hauts-de-France'],
  ['60', 'Oise', 'Hauts-de-France'],
  ['61', 'Orne', 'Normandie'],
  ['62', 'Pas-de-Calais', 'Hauts-de-France'],
  ['63', 'Puy-de-Dôme', 'Auvergne-Rhône-Alpes'],
  ['64', 'Pyrénées-Atlantiques', 'Nouvelle-Aquitaine'],
  ['65', 'Hautes-Pyrénées', 'Occitanie'],
  ['66', 'Pyrénées-Orientales', 'Occitanie'],
  ['67', 'Bas-Rhin', 'Grand Est'],
  ['68', 'Haut-Rhin', 'Grand Est'],
  ['69', 'Rhône', 'Auvergne-Rhône-Alpes'],
  ['70', 'Haute-Saône', 'Bourgogne-Franche-Comté'],
  ['71', 'Saône-et-Loire', 'Bourgogne-Franche-Comté'],
  ['72', 'Sarthe', 'Pays de la Loire'],
  ['73', 'Savoie', 'Auvergne-Rhône-Alpes'],
  ['74', 'Haute-Savoie', 'Auvergne-Rhône-Alpes'],
  ['75', 'Paris', 'Île-de-France'],
  ['76', 'Seine-Maritime', 'Normandie'],
  ['77', 'Seine-et-Marne', 'Île-de-France'],
  ['78', 'Yvelines', 'Île-de-France'],
  ['79', 'Deux-Sèvres', 'Nouvelle-Aquitaine'],
  ['80', 'Somme', 'Hauts-de-France'],
  ['81', 'Tarn', 'Occitanie'],
  ['82', 'Tarn-et-Garonne', 'Occitanie'],
  ['83', 'Var', 'Provence-Alpes-Côte d’Azur'],
  ['84', 'Vaucluse', 'Provence-Alpes-Côte d’Azur'],
  ['85', 'Vendée', 'Pays de la Loire'],
  ['86', 'Vienne', 'Nouvelle-Aquitaine'],
  ['87', 'Haute-Vienne', 'Nouvelle-Aquitaine'],
  ['88', 'Vosges', 'Grand Est'],
  ['89', 'Yonne', 'Bourgogne-Franche-Comté'],
  ['90', 'Territoire de Belfort', 'Bourgogne-Franche-Comté'],
  ['91', 'Essonne', 'Île-de-France'],
  ['92', 'Hauts-de-Seine', 'Île-de-France'],
  ['93', 'Seine-Saint-Denis', 'Île-de-France'],
  ['94', 'Val-de-Marne', 'Île-de-France'],
  ['95', 'Val-d’Oise', 'Île-de-France'],
];

const OUTRE_MER: Departement[] = [
  { code: '971', nom: 'Guadeloupe', region: 'Outre-mer', fuseau: 'America/Guadeloupe' },
  { code: '972', nom: 'Martinique', region: 'Outre-mer', fuseau: 'America/Martinique' },
  { code: '973', nom: 'Guyane', region: 'Outre-mer', fuseau: 'America/Cayenne' },
  { code: '974', nom: 'La Réunion', region: 'Outre-mer', fuseau: 'Indian/Reunion' },
  { code: '976', nom: 'Mayotte', region: 'Outre-mer', fuseau: 'Indian/Mayotte' },
];

export const DEPARTEMENTS: readonly Departement[] = [
  ...METROPOLE.map(([code, nom, region]) => ({ code, nom, region, fuseau: PARIS })),
  ...OUTRE_MER,
];

const PAR_CODE = new Map(DEPARTEMENTS.map((d) => [d.code, d]));

export function departement(code: string): Departement | undefined {
  return PAR_CODE.get(code);
}

/**
 * Le département d'un code postal : 20xxx se partage entre les deux Corse
 * (200/201 → 2A, sinon 2B), 97x et 976 se lisent sur trois chiffres.
 */
export function departementDuCodePostal(codePostal: string): Departement | undefined {
  const cp = codePostal.replace(/\s/g, '');
  if (!/^\d{5}$/.test(cp)) return undefined;
  if (cp.startsWith('97')) return PAR_CODE.get(cp.slice(0, 3));
  if (cp.startsWith('20')) return PAR_CODE.get(Number(cp.slice(0, 3)) < 202 ? '2A' : '2B');
  return PAR_CODE.get(cp.slice(0, 2));
}

/**
 * Un bâtiment neuf se construit seulement en Corse et outre-mer (règle VLA du
 * 14 octobre 2026) ; en métropole, le séchoir s'aménage toujours dans un
 * bâtiment existant.
 */
export function constructionPossible(code: string): boolean {
  const r = departement(code)?.region;
  return r === 'Corse' || r === 'Outre-mer';
}

/** Les régions, dans l'ordre d'affichage : métropole alphabétique, Corse, puis outre-mer. */
export function regions(): string[] {
  const toutes = [...new Set(DEPARTEMENTS.map((d) => d.region))];
  const metro = toutes
    .filter((r) => r !== 'Corse' && r !== 'Outre-mer')
    .sort((a, b) => a.localeCompare(b, 'fr'));
  return [...metro, 'Corse', 'Outre-mer'];
}

/** « 12, 31, 81, 82 » ; au-delà de six, « Occitanie (13) + 2 ». */
export function resumerZones(codes: readonly string[]): string {
  if (codes.length === 0) return 'Aucune zone';
  if (codes.length <= 6) return [...codes].sort(comparerCodes).join(', ');
  const parRegion = new Map<string, number>();
  for (const code of codes) {
    const region = departement(code)?.region ?? '?';
    parRegion.set(region, (parRegion.get(region) ?? 0) + 1);
  }
  const [principale] = [...parRegion.entries()].sort((a, b) => b[1] - a[1]);
  if (!principale) return `${codes.length} départements`;
  const reste = codes.length - principale[1];
  return reste > 0
    ? `${principale[0]} (${principale[1]}) + ${reste}`
    : `${principale[0]} (${principale[1]})`;
}

export function comparerCodes(a: string, b: string): number {
  const rang = (c: string) => (c === '2A' ? 20.1 : c === '2B' ? 20.2 : Number(c));
  return rang(a) - rang(b);
}
